import React from 'react';
import ClassSelectPage from './ClassSelectPage';

const ScheduleSelectPage = () => {
  return <ClassSelectPage type="schedule" />;
};

export default ScheduleSelectPage;







